import {
  TableRow,
  TableBody,
  TableCell,
  TableContainer,
  Paper,
  Table,
  TableHead,
  Button,
  CircularProgress,
  Box,
} from "@mui/material";

import Iconify from "../iconify/Iconify";
import { fDateTime } from "src/utils/formatTime";
import { getDivisionNameByLevel } from "src/utils/cardUtils";

export default function UserDivisionLeaguesTable(props) {
  return props.rows === null ? (
    <Box
      sx={{ display: "flex", justifyContent: "center" }}
      style={{ padding: 20 }}
    >
      <CircularProgress />
    </Box>
  ) : (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>League ID</TableCell>
            <TableCell>Name</TableCell>
            <TableCell>Rank</TableCell>
            <TableCell>Points</TableCell>
            <TableCell>Joined At</TableCell>
            <TableCell>Stage Period</TableCell>
            <TableCell>IsActive</TableCell>
            <TableCell align="right"></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props?.rows?.map((row, index) => (
            <TableRow
              key={index}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
              }}
            >
              <TableCell component="th" scope="row">
                {row.leagueId}
              </TableCell>
              <TableCell component="th" scope="row">
                {getDivisionNameByLevel(row.divisionId)}
              </TableCell>
              <TableCell component="th" scope="row">
                {row.rank}
              </TableCell>
              <TableCell component="th" scope="row">
                {row.points}
              </TableCell>
              <TableCell component="th" scope="row">
                {fDateTime(new Date(row.membershipCreatedAt))}
              </TableCell>
              <TableCell component="th" scope="row">
                {row.stagePeriodId}
              </TableCell>

              <TableCell component="th" scope="row">
                {row.isActive ? (
                  <Iconify
                    icon={"eva:checkmark-circle-2-outline"}
                    sx={{ color: "green" }}
                  />
                ) : (
                  <Iconify
                    icon={"eva:close-circle-outline"}
                    sx={{ color: "red" }}
                  />
                )}
              </TableCell>
              <TableCell align="right">
                {props.showLeaderboard && (
                  <Button
                    variant="outlined"
                    onClick={() => props.onLeaderboardClick(row.leagueId)}
                    sx={{ mr: 2 }}
                  >
                    Leaderboard
                  </Button>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
